export enum InitialNavPillsEnum {
  LOGIN_CUSTOMER,
}
